<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="`Delete Observation - ${observation.observation_id} :: MeritEHS`" />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/observations`">
                            <i class="fa fa-comment-o"></i> Observations
                        </router-link>
                    </li>
                    <template>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/observations/view/${observation.observation_id}`">
                                {{ observation.observation_date  | moment("MM/DD/YYYY") }} - {{ observation.FirstName + ' ' + observation.LastName  }} - JOB#{{ observation.JobsiteNumber }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Delete</li>
                    </template>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-4 col-lg-6">
                    <div class="alert alert-danger">
                        <strong>Warning:</strong> You are about to delete this observation and all of its data. This change <strong>cannot be undone.</strong>
                    </div>

                    <b-button variant="danger" v-on:click="deleteObservation()" :disabled="saving">
                        <template v-if="saving">
                            Deleting...
                        </template>
                        <template v-else>
                            <i class="fa fa-trash"></i> Delete Observation
                        </template>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                observation_id: this.$route.params.id,
                observation: {},
            }
        },

        methods: {

            getObservation() {
                //Get the data
                this.$http
                    .get('observations/view/' + this.observation_id)
                    .then(response => {
                        //Set all the data
                        this.observation = response.data.observation;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteObservation() {
                //SHow loading
                this.saving = true;

                //Send it
                this.$http
                .post('observations/delete/' + this.observation_id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Observation Deleted');

                    //Return to main list?
                    this.$router.push('/observations');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {

                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },
        mounted() {
            //Get the observation
            this.getObservation();
        }
    }
</script>
